import { useContext } from 'react';
import { UploadStateContext } from '@/components/upload-core/context';
export const useShowPreview = (file) => {
    const { onPreview } = useContext(UploadStateContext);
    const isUploading = file.status && ['idle', 'uploading'].includes(file.status);
    if (isUploading)
        return false;
    return (onPreview || file.url) && file.allowPreview !== false;
};
